import { bl_fi_internal_purchase_invoice_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class PurchaseInvoiceFileImportHelperContainerModel extends BaseContainerModel {
    bl_fi_internal_purchase_invoice_import_file_helper: bl_fi_internal_purchase_invoice_import_file_helper_RowClass = new bl_fi_internal_purchase_invoice_import_file_helper_RowClass();
}